import React, { useState } from "react";
import { Container, Col, Row, Accordion, Card, Button } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { FiPlus, FiMinus } from "react-icons/fi";

import { IoArrowForwardOutline } from "react-icons/io5";
// import { RiDoubleQuotesL } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import AIPoweredimg1 from "../../assets/publicpageimg/industry-learning.svg";
import AIPoweredimg2 from "../../assets/publicpageimg/hands-on-experience.svg";
import AIPoweredimg3 from "../../assets/publicpageimg/career-ready-skills.svg";
import AIPoweredimg4 from "../../assets/publicpageimg/learn-by-collaboration.svg";
import AIPoweredimg5 from "../../assets/publicpageimg/quality-learning-experience.svg";
import AIPoweredimg6 from "../../assets/publicpageimg/continuous-growth.svg";

import CareersImage from "../../assets/publicpageimg/building-careers-through-industry1.png";

import AccelerateYourCareer from "../../assets/publicpageimg/accelerate-your-career.png";
import BuildSolveStandOut from "../../assets/publicpageimg/ai-powered.png";
import LearnByDoingWork from "../../assets/publicpageimg/teamwork.png";
import LearnFromIndustry from "../../assets/publicpageimg/guided-mentor1.png";
import ShapeYourFuture from "../../assets/publicpageimg/empower.png";

import ReadyBuildRealSkills from "../../assets/publicpageimg/about-ready-to-build.png";
// import user1 from "../../assets/publicpageimg/review-avatar.png";

import "./AboutUs.css";

const aboutCards = [
  {
    image: AIPoweredimg1,
    title: " Industry Learning",
    text: "We design every program around current industry practices, ensuring students gain practical skills that match real workplace expectations.",
  },
  {
    image: AIPoweredimg2,
    title: "Hands-On Experience",
    text: "Learning goes beyond theory. Students build projects, solve real-world challenges, and apply their knowledge through practical assignments and internships.",
  },
  {
    image: AIPoweredimg3,
    title: "Career-Ready Skills",
    text: "Develop practical, technical, and professional skills that prepare you for real-world challenges and long-term career success.",
  },
  {
    image: AIPoweredimg4,
    title: "Learn by Collaboration",
    text: "Students work alongside peers on team-based projects, improving communication, collaboration, and real-world development experience.",
  },
  {
    image: AIPoweredimg5,
    title: "Quality Learning Experience",
    text: "From curriculum design to project reviews, we maintain high standards to deliver engaging, practical, and outcome-focused learning",
  },
  {
    image: AIPoweredimg6,
    title: "Continuous Growth",
    text: "Learning doesn't stop after a course. We encourage continuous skill development, portfolio building, and career advancement through every stage of the journey.",
  },
];

const faqsData = [
  {
    question: "Are the courses beginner friendly?",
    answer:
      "Yes, our courses start from fundamentals and gradually move towards advanced, real-world applications.",
  },
  {
    question: "What is the mission of Skilledition?",
    answer:
      "Skilledition’s mission is to bridge the gap between academic learning and industry requirements by providing practical, job-oriented education.",
  },
  {
    question: "Why should I trust Skilledition as a learning platform?",
    answer:
      "Skilledition focuses on hands-on learning, structured curriculum, student mentorship, and continuous career support.",
  },
  {
    question: "Does Skilledition focus on practical learning?",
    answer:
      "Yes, every course includes live sessions, assignments, projects, and real-world use cases.",
  },
  {
    question: "Who are the mentors at Skilledition?",
    answer:
      "Our mentors are industry professionals with real-time project and corporate experience.",
  },
];

// const reviews = [
//   {
//     name: "Satish Kumar",
//     year: "BTech – 4th Year",
//     image: user1,
//     text: "Skilledition helped me understand coding concepts in a very simple way. The mentors explain everything practically, which boosted my confidence in web development.",
//   },
//   {
//     name: "Anjali Reddy",
//     year: "BSc – 3rd Year",
//     image: user1,
//     text: "I had zero knowledge of programming before joining Skilledition. The step-by-step approach and real-time examples made learning very easy and enjoyable.",
//   },
//   {
//     name: "Rahul Verma",
//     year: "BCA – Final Year",
//     image: user1,
//     text: "The projects and assignments at Skilledition are industry-focused. They helped me build a strong portfolio and prepare for interviews confidently.",
//   },
//   {
//     name: "Priya Sharma",
//     year: "MBA – 2nd Year",
//     image: user1,
//     text: "I loved how Skilledition focuses on practical learning instead of theory. The live sessions and doubt-solving support were extremely helpful.",
//   },
//   {
//     name: "Karthik S",
//     year: "BTech – 3rd Year",
//     image: user1,
//     text: "Skilledition’s teaching style is beginner-friendly. Even complex topics like React and JavaScript were explained clearly with real-world use cases.",
//   },
//   {
//     name: "Neha Patel",
//     year: "BCom – Final Year",
//     image: user1,
//     text: "The flexibility of learning and recorded sessions helped me balance my college studies while improving my technical skills.",
//   },
//   {
//     name: "Amit Singh",
//     year: "BTech – 2nd Year",
//     image: user1,
//     text: "After joining Skilledition, my problem-solving skills improved a lot. The trainers motivate students and provide constant guidance.",
//   },
//   {
//     name: "Divya Nair",
//     year: "MCA – 1st Year",
//     image: user1,
//     text: "Skilledition gave me hands-on experience with real projects. This helped me understand how things work in actual development environments.",
//   },
//   {
//     name: "Rohit Deshmukh",
//     year: "BTech – 3rd Year",
//     image: user1,
//     text: "The Backend Development course at Skilledition helped me understand server-side concepts thoroughly. Deploying my first Node.js app was a great experience.",
//   },
//   {
//     name: "Sneha Rao",
//     year: "BBA – 2nd Year",
//     image: user1,
//     text: "Digital Marketing training at Skilledition completely changed my perspective. I learned SEO, social media strategies, and analytics with real campaign examples.",
//   },
//   {
//     name: "Vivek Yadav",
//     year: "BCA – Final Year",
//     image: user1,
//     text: "The Frontend Development course helped me build responsive websites using HTML, CSS, and Bootstrap. Mentors explained everything practically, and projects were very engaging.",
//   },
//   {
//     name: "Meera Iyer",
//     year: "MBA – 1st Year",
//     image: user1,
//     text: "Skilledition’s project-based learning is amazing. I completed a full social media marketing project and got real experience handling campaigns.",
//   },
//   {
//     name: "Aditya Sharma",
//     year: "BTech – 4th Year",
//     image: user1,
//     text: "I appreciated the constant mentorship and guidance. From beginner to advanced backend topics, the learning path was smooth and practical.",
//   },
//   {
//     name: "Ritika Sen",
//     year: "BSc – 3rd Year",
//     image: user1,
//     text: "The assignments and mini-projects made learning Digital Marketing interactive. I now feel confident running SEO and paid campaigns independently.",
//   },
//   {
//     name: "Sahil Kapoor",
//     year: "MCA – 2nd Year",
//     image: user1,
//     text: "Skilledition helped me strengthen my JavaScript and React skills. The practical approach, live coding sessions, and real projects prepared me for industry roles.",
//   },
//   {
//     name: "Ananya Ghosh",
//     year: "BCom – Final Year",
//     image: user1,
//     text: "The course content was well-structured and relevant. I enjoyed learning backend with Node.js and Express.js, and the real-time projects boosted my confidence.",
//   },
// ];

const AboutUs = () => {
  const [activeKey, setActiveKey] = useState("0");
  // const repeatedReviews = [...reviews, ...reviews, ...reviews];
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Skilledition | About Us - Building Career-Ready Skills</title>

        <meta
          name="description"
          content="Discover Skilledition's mission to help learners build career-ready skills through industry-focused courses, real-world projects, expert mentorship, and internship opportunities."
        />

        <link rel="canonical" href="https://skilledition.in/about" />

        <meta
          property="og:title"
          content="Skilledition | About Us - Building Career-Ready Skills"
        />
        <meta
          property="og:description"
          content="Learn how Skilledition helps students build practical skills through industry-focused learning, real-world projects, mentorship, and career support."
        />
        <meta property="og:url" content="https://skilledition.in/about" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner.png"
        />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | About Us - Building Career-Ready Skills"
        />
        <meta
          name="twitter:description"
          content="Discover Skilledition's vision for practical learning, real projects, mentorship, and career-focused skill development."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner.png"
        />
      </Helmet>

      <section className="skilledition-about-company-section">
        <Container>
          <h2 className="skilledition-about-company-title">
            About Our Company
          </h2>

          <div className="about-grid">
            {/* LEFT COLUMN */}
            <div className="about-column">
              <Card
                className="skilledition-about-company-card purple about-card-animate"
                style={{ animationName: "slideInLeft", animationDelay: "0.1s" }}
              >
                <Card.Body className="p-0">
                  <img
                    src={AccelerateYourCareer}
                    alt="Students"
                    className="skilledition-about-company-students-empowered"
                  />
                  <Card.Title>Accelerate Your Career</Card.Title>
                  <Card.Text>
                    Get job-ready 10x faster with a hands-on learning approach.
                    Work on real projects, complete internships, and build a
                    portfolio that gets you noticed.
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card
                className="skilledition-about-company-card light-blue about-card-animate"
                style={{ animationName: "slideInLeft", animationDelay: "0.2s" }}
              >
                <Card.Body className="p-0">
                  <img
                    src={BuildSolveStandOut}
                    alt="Projects"
                    className="skilledition-about-company-Real-World"
                  />
                  <Card.Title>Build. Solve. Stand Out.</Card.Title>
                  <Card.Text>
                    Work on real-world projects designed around actual industry
                    challenges. Solve problems, build practical solutions, and
                    create a portfolio that showcases your skills to employers.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>

            {/* MIDDLE CARD */}
            <Card
              className="skilledition-about-company-card light-blue middle-card about-card-animate"
              style={{ animationName: "slideInBottom", animationDelay: "0.3s" }}
            >
              <Card.Body className="middle-card-body">
                <div className="middle-card-text">
                  <Card.Title>Learn by Doing, Work with Real Teams</Card.Title>
                  <Card.Text>
                    Experience how real teams collaborate, plan, and deliver.
                    Our programs are built around industry workflows, tools, and
                    processes so you gain practical skills and the confidence to
                    contribute from day one.
                  </Card.Text>
                </div>
                <img
                  src={LearnByDoingWork}
                  alt="Team Work"
                  className="skilledition-about-company-Learn-img"
                />
              </Card.Body>
            </Card>

            {/* RIGHT COLUMN */}
            <div className="about-column">
              <Card
                className="skilledition-about-company-card light-blue about-card-animate"
                style={{
                  animationName: "slideInRight",
                  animationDelay: "0.4s",
                }}
              >
                <Card.Body className="p-0">
                  <img
                    src={LearnFromIndustry}
                    alt="Mentors"
                    className="skilledition-about-company-guided-by-industry"
                  />
                  <Card.Title>Learn from Industry Experts</Card.Title>
                  <Card.Text>
                    Get mentored by professionals who have built and scaled real
                    products. Receive personalized feedback and practical
                    insights that guide your growth.
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card
                className="skilledition-about-company-card yellow about-card-animate"
                style={{
                  animationName: "slideInRight",
                  animationDelay: "0.5s",
                }}
              >
                <Card.Body className="p-0">
                  <img
                    src={ShapeYourFuture}
                    alt="Students"
                    className="skilledition-about-company-students-empowered"
                  />
                  <Card.Title>Shape Your Future with Us</Card.Title>
                  <Card.Text>
                    Become part of a thriving learning community where you'll
                    connect with mentors, collaborate with peers, and access the
                    guidance you need to achieve your career goals.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Container>
      </section>

      <section className="skilledition-aboutpage-section reveal">
        <Container>
          <Row className="mb-3">
            <Col lg={6}>
              <h2 className="skilledition-aboutpage-title">
                Learn Today.
                <br />
                Build Tomorrow.
              </h2>
            </Col>

            <Col lg={6}>
              <p className="skilledition-aboutpage-desc">
                At Skilledition, we empower learners with industry-relevant
                skills through hands-on projects and real-world internships,
                helping them become confident, career-ready professionals.
              </p>
            </Col>
          </Row>

          <Row>
            {aboutCards.map((item, index) => (
              <Col lg={4} md={6} sm={1} className="mb-4" key={index}>
                <Card className="skilledition-aboutpage-card">
                  <div className="skilledition-aboutpage-icon">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="skilledition-aboutpage-icon-img"
                    />
                  </div>
                  <Card.Body className="p-0">
                    <Card.Title className="skilledition-aboutpage-card-title">
                      {item.title}
                    </Card.Title>

                    <Card.Text className="skilledition-aboutpage-card-text">
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="skilledition-aboutpage-careers-section reveal">
        <Container>
          <Row className="align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6}>
              <h2 className="skilledition-aboutpage-careers-title">
                Building Careers
                <br />
                Through Industry-Ready Skills
              </h2>

              <p className="skilledition-aboutpage-careers-desc">
                We empower learners to go beyond theory by building real-world
                projects, gaining practical experience, and developing the
                skills needed for long-term career success across industries.
              </p>

              <ul className="skilledition-aboutpage-careers-list">
                <li>
                  <FaCheck className="skilledition-aboutpage-careers-icon" />
                  Hands-on Project-Based Learning
                </li>
                <li>
                  <FaCheck className="skilledition-aboutpage-careers-icon" />
                  Real-World Internship Experience
                </li>
                <li>
                  <FaCheck className="skilledition-aboutpage-careers-icon" />
                  Career-Focused Skill Development
                </li>
              </ul>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} className="text-center">
              <div className="skilledition-aboutpage-careers-image-wrapper">
                <img
                  src={CareersImage}
                  alt="Industry Ready Skills"
                  className="skilledition-aboutpage-careers-image"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section className="skilledition-about-reviews-section text-center py-5 reveal">
        <h2 className="skilledition-about-reviews-title">
          What learners say about <br />
          Skilledition
        </h2>

        <div className="skilledition-about-reviews-marquee-wrapper">
          <div className="skilledition-about-reviews-marquee skilledition-about-reviews-move-left">
            {repeatedReviews.map((item, index) => (
              <div
                className="skilledition-about-reviews-card"
                key={`top-${index}`}
              >
                <div className="skilledition-about-reviews-quote">
                  <RiDoubleQuotesL />
                </div>
                <p className="skilledition-about-reviews-text">{item.text}</p>

                <div className="skilledition-about-reviews-student">
                  <div className="skilledition-about-reviews-avatar">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="skilledition-about-reviews-avatar-img"
                    />
                  </div>
                  <div>
                    <p className="skilledition-about-reviews-name">
                      {item.name}
                    </p>
                    <p className="skilledition-about-reviews-year">
                      {item.year}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="skilledition-about-reviews-marquee-wrapper mt-4">
          <div className="skilledition-about-reviews-marquee skilledition-about-reviews-move-right">
            {repeatedReviews.map((item, index) => (
              <div
                className="skilledition-about-reviews-card"
                key={`bottom-${index}`}
              >
                <div className="skilledition-about-reviews-quote">
                  <RiDoubleQuotesL />
                </div>

                <p className="skilledition-about-reviews-text">{item.text}</p>

                <div className="skilledition-about-reviews-student">
                  <div className="skilledition-about-reviews-avatar">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="skilledition-about-reviews-avatar-img"
                    />
                  </div>
                  <div>
                    <p className="skilledition-about-reviews-name">
                      {item.name}
                    </p>
                    <p className="skilledition-about-reviews-year">
                      {item.year}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>
              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Ready to Build <br /> Real Skills
              </h2>

              <p className="skilledition-banner-section-text">
                Choose your learning path, master in-demand skills, and become
                career-ready through practical learning.
              </p>

              <Button
                className="skilledition-banner-section-btn"
                onClick={() => navigate("/courses")}
              >
                Start Learning <IoArrowForwardOutline />
              </Button>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={ReadyBuildRealSkills}
                alt="Skilledition career-ready learning banner"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default AboutUs;
